import d from "lodash-es/camelCase";
import a from "lodash-es/get";
import g from "lodash-es/isFinite";
import C from "lodash-es/isPlainObject";
import { INBOUND_LEADS as b, SELLER_STATUSES as y, ORDER as S, LICENSE_COLORS as N } from "../constants.js";
const L = "BULK", f = ".mount-point-container";
function k(r, e) {
  return Object.keys(e).length ? r.filter((t) => {
    for (const c in e) {
      const s = e[c], l = s.filterBy;
      let i = a(t, c.split("."));
      if (C(i) && (i = t[c].id), "customFilter" in s) {
        if (!s.customFilter(l, i, t))
          return !1;
      } else if (!Array.isArray(i) && !~l.indexOf(i))
        return !1;
    }
    return !0;
  }) : r;
}
function w(r, e) {
  const { sortBy: t, sortDesc: c, customSorter: s, locale: l = "en" } = e, i = r.length && typeof r[0] == "object";
  return !t && i ? r : [...r].sort((m, p) => {
    let o = a(m, t) || m, n = a(p, t) || p;
    if (c && ([o, n] = [n, o]), s)
      return s(o, n);
    if ([o, n] = [o, n].map((u) => (u || "").toString().toLocaleLowerCase()), o !== n) {
      const u = !isNaN(o) && !isNaN(n) ? Number(o) - Number(n) : o.localeCompare(n, l);
      if (u)
        return u;
    }
    return 0;
  });
}
function B(r) {
  return g(r) && (r = r.toString()), !r || typeof r != "string" ? "" : r.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function D(r) {
  return r.split("").reduce((e, t) => (e = (e << 5) - e + t.charCodeAt(0), e & e), 0);
}
function I() {
  const r = document.querySelector(f);
  if (!r) {
    const e = document.createElement("div");
    return e.className = f.slice(1, f.length), document.body.appendChild(e);
  }
  return r;
}
function R(r) {
  let e = r;
  return e.substring(0, 2) !== "--" && (e = `--${e}`), getComputedStyle(document.documentElement).getPropertyValue(e);
}
function O(r = "") {
  const e = r.toUpperCase();
  return e === L ? e : e.slice(0, 3);
}
function _(r, e) {
  let t;
  try {
    switch (r) {
      case "license":
        e = O(e), t = N[e];
        break;
      case "order":
        t = "tw-bg-" + S[e.toUpperCase()].color;
        break;
      case "certified-seller":
        t = y[d(e)].color;
        break;
      case "inbound-leads":
        t = b[e.toUpperCase()].color;
        break;
    }
    return t || "tw-bg-ice-500";
  } catch {
    return "tw-bg-ice-500";
  }
}
export {
  k as filterItems,
  O as formatLicenseTypeText,
  _ as generateColorClass,
  R as getCssVar,
  I as getMountPoint,
  D as hashCode,
  B as normalizeText,
  w as sortItems
};
//# sourceMappingURL=helpers.js.map
